import "../pages.scss";
import { ThemeState } from '../../context/theme/ThemeState';
import Datatable from "./themeTable/Datatable"

const ThemePage = () => { 
  return (
    <>
      <ThemeState>
        <Datatable />
      </ThemeState>
    </>
  )
}

export default ThemePage